"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _selectors = require("../session/selectors");
var _selectors2 = require("./selectors");
var _actions = require("./actions");
var _actions2 = require("../notification/actions");
var _reduxBatchedActions = require("redux-batched-actions");
var _constants = require("./constants");
var _middlewares = require("./middlewares");
var _api = require("../../utils/api");
var _middlewares2 = require("../network/middlewares");
var _schemas = require("./schemas");
var _types2 = require("../websocket/types");
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var logger = new _logger.default('saga:notifications');
function getNotifications(_ref) {
  var {
    category,
    notificationType,
    limit,
    page,
    ignored,
    read
  } = _ref;
  return function* () {
    var categoryFullname = (0, _middlewares.getCategoryFullname)({
      category,
      notificationType,
      read
    });
    try {
      logger.log('getNotifications', category, notificationType, limit, page, ignored, read);
      yield (0, _effects.put)((0, _actions.setLoadingNotificationsByCategory)(categoryFullname, true));
      var {
        data,
        headers
      } = yield (0, _effects.call)(_apis.$getNotifications, category, notificationType, limit, page, ignored, read);
      if (read === undefined) {
        var _getContentRange;
        yield (0, _effects.put)((0, _actions.setCountNotificationsByCategory)(category, (_getContentRange = (0, _api.getContentRange)(headers)) === null || _getContentRange === void 0 ? void 0 : _getContentRange.count));
      }
      if (read === false) {
        var _getContentRange2;
        yield (0, _effects.put)((0, _actions.setUnreadCountNotificationsByCategory)(category, (_getContentRange2 = (0, _api.getContentRange)(headers)) === null || _getContentRange2 === void 0 ? void 0 : _getContentRange2.count));
      }
      var notifications = [];
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      for (var index = 0; index < data.length; index++) {
        var notification = data[index];
        notifications.push(yield (0, _middlewares.notificationEnrichment)({
          notification,
          _client,
          _user
        }));
      }
      yield (0, _effects.put)((0, _actions.setNotificationCategory)(category));
      if (notifications !== null && notifications !== void 0 && notifications.length) {
        var _notifications = yield* (0, _api.normalizeApiResponse)(notifications, [_schemas.notifications]);
        if (_config.default.saveNotifByCategory && category) {
          if (!page || page < 2) {
            yield (0, _effects.put)((0, _actions.setNotificationsByCategory)(categoryFullname, _notifications));
          } else {
            yield (0, _effects.put)((0, _actions.addNotificationsByCategory)(categoryFullname, _notifications));
          }
        } else {
          yield (0, _effects.put)((0, _actions.setNotifications)(_notifications));
        }
      } else {
        if (_config.default.saveNotifByCategory && category) {
          yield (0, _effects.put)((0, _actions.setNotificationsByCategory)(categoryFullname, []));
        } else {
          yield (0, _effects.put)((0, _actions.setNotifications)([]));
        }
      }
    } catch (e) {
      if (!(0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'NO1',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e);
      }
    } finally {
      yield (0, _effects.put)((0, _actions.setLoadingNotificationsByCategory)(categoryFullname, false));
    }
  }();
}
function getNotificationsCount(_ref2) {
  var {
    ignored,
    read
  } = _ref2;
  return function* () {
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getUnreadNotificationCount, ignored, read);
      if (data !== undefined) {
        yield (0, _effects.put)((0, _actions.setAllUnreadCountNotifications)(data));
      }
    } catch (e) {
      if (!(0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'NO2',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e);
      }
    }
  }();
}
function markNotificationsAsRead(_ref3) {
  var {
    notificationType,
    category
  } = _ref3;
  return function* () {
    logger.log('markNotificationsAsRead', {
      notificationType,
      category
    });
    try {
      var isAuthenticated = yield (0, _effects.select)(_selectors.userLogged);
      if (isAuthenticated) {
        yield (0, _effects.call)(_apis.$markNotificationsAsRead, category, notificationType);
        yield (0, _effects.put)((0, _actions.setUnreadCountNotificationsByCategory)(category, 0));
        if (_config.default.saveNotifByCategory) {
          var categoryFullname = (0, _middlewares.getCategoryFullname)({
            category,
            notificationType,
            read: false
          });
          var unread = yield (0, _effects.select)(state => state.notifications[categoryFullname]);
          if (unread !== null && unread !== void 0 && unread.length) {
            yield (0, _effects.put)((0, _actions.setNotificationsByCategory)(categoryFullname, []));
            yield (0, _effects.put)((0, _actions.setNotificationsEntititesToReadByCategory)(category));
          }
        }
      }
    } catch (e) {
      if (!(0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'NO3',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e);
      }
    }
  }();
}
function* updateNotifications() {
  try {
    yield (0, _effects.call)(_apis.$patchNotification);
  } catch (e) {
    if (!(0, _middlewares2.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'NO4',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }
}
function* processNotification(payload) {
  if (payload) {
    logger.log('processNotification', payload);
    var batchedActions = [];
    var currentCategory = yield (0, _effects.select)(_selectors2.getCurrentNotificationCategorySelector);
    var _notifications = yield (0, _effects.select)(_selectors2.notificationIdsSelector);
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var notification = yield (0, _middlewares.notificationEnrichment)({
      notification: payload,
      _client,
      _user
    });
    var {
      batchedAction,
      result
    } = yield* (0, _api.normalizeApiResponse)(notification, _schemas.notifications, true);
    batchedActions.push(batchedAction);
    if (_config.default.saveNotifByCategory) {
      var read = payload.viewed === false ? false : undefined;
      batchedActions.push((0, _actions.addNewNotificationByCategory)((0, _middlewares.getCategoryFullname)({
        category: payload.category
      }), result));
      if (!read) {
        batchedActions.push((0, _actions.addNewNotificationByCategory)((0, _middlewares.getCategoryFullname)({
          category: payload.category,
          read
        }), result));
      }
      batchedActions.push((0, _actions.addNewNotificationByCategory)((0, _middlewares.getCategoryFullname)({
        category: payload.category,
        notificationType: payload.type
      }), result));
      batchedActions.push((0, _actions.addNewNotificationByCategory)((0, _middlewares.getCategoryFullname)({
        category: payload.category,
        notificationType: payload.type,
        read
      }), result));
    } else if (!(_notifications !== null && _notifications !== void 0 && _notifications.includes(payload === null || payload === void 0 ? void 0 : payload.id)) && (currentCategory === payload.category || _constants.QUICKACTIONS_CATEGORIES.includes(payload.category) && currentCategory === _constants.VIRTUAL_CATEGORIES.QUICKACTIONS)) {
      batchedActions.push((0, _actions.addNewNotification)(result));
    }
    yield (0, _effects.call)(getNotificationsCount, {
      read: false
    });
    yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
  }
}
function updateNotification(_ref4) {
  var {
    payload
  } = _ref4;
  return function* () {
    logger.log('updateNotification', {
      payload
    });
    yield (0, _effects.call)(processNotification, payload);
  }();
}
function updateUnreadNotificationCount(_ref5) {
  var {
    payload
  } = _ref5;
  return function* () {
    logger.log('updateUnreadNotificationCount', {
      payload
    });
    yield (0, _effects.put)((0, _actions.setAllUnreadCountNotifications)(payload));
  }();
}
function wsDeleteNotifications(_ref6) {
  var {
    payload
  } = _ref6;
  return function* () {
    logger.log('wsDeleteNotification', {
      payload
    });
    yield (0, _effects.put)((0, _actions.removeNotificationFromEntities)(payload === null || payload === void 0 ? void 0 : payload.id));
    yield (0, _effects.call)(getNotificationsCount, {
      read: false
    });
  }();
}
function* getNotificationsWhenConnected() {
  if (!_config.default.fetchNotifWhenWSConnected) return;
  logger.log('getNotificationsWhenConnected');
  yield (0, _effects.call)(getNotifications, {
    category: _constants.CATEGORIES.ROOM,
    read: false,
    limit: _constants.NOTIFICATIONS_LIMIT
  });
  yield (0, _effects.call)(getNotifications, {
    category: _constants.CATEGORIES.ROOM,
    limit: _constants.NOTIFICATIONS_LIMIT
  });
}
function getNextNotificationLogic(_ref7) {
  var {
    category,
    notificationType,
    read
  } = _ref7;
  return function* () {
    logger.log('getNextNotificationLogic', {
      category,
      notificationType,
      read
    });
    var totalCount = yield (0, _effects.select)(_selectors2.getNotificationTotalCountsSelector);
    var _notif = yield (0, _effects.select)(_selectors2._getAllNotificationsByCategory, category);
    var count = (_notif || []).length;
    var totalCountCategory = totalCount[category];
    if (!totalCountCategory || totalCountCategory > count) {
      var nextPage = Math.floor(count / _constants.NOTIFICATIONS_LIMIT) + 1;
      yield (0, _effects.call)(getNotifications, {
        category: _constants.CATEGORIES.ROOM,
        page: nextPage,
        notificationType,
        read
      });
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _effects.takeLatest)(_types2.WS_CONNECT, getNotificationsWhenConnected), (0, _effects.takeLatest)(types.REQUEST_GET_NOTIFICATIONS, getNotifications), (0, _effects.takeLatest)(types.REQUEST_GET_NEXT_NOTIFICATIONS, getNextNotificationLogic), (0, _effects.takeLatest)(types.REQUEST_NOTIFICATION_COUNT, getNotificationsCount), (0, _effects.takeLatest)(types.REQUEST_MARK_NOTIFICATIONS_AS_READ, markNotificationsAsRead), (0, _effects.takeLatest)(types.REQUEST_PATCH_NOTIFICATION, updateNotifications), (0, _effects.takeEvery)(types.WS_DELETE_NOTIFICATION, wsDeleteNotifications), (0, _effects.takeEvery)([types.WS_POST_NOTIFICATION, types.WS_PUT_NOTIFICATION], updateNotification), (0, _effects.takeLatest)(types.WS_COUNT_NOT_VIEWED_NOTIFICATIONS, updateUnreadNotificationCount)]);
}
module.exports = exports.default;